import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade + rise reveal on scroll into view.
export function Reveal({ children, delay = 0, y = 26, className, as = "div", once = true }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-12% 0px -12% 0px" }}
      transition={{ duration: 1.05, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
}

// Masked line-by-line reveal (used for the hero title on load).
export function MaskedLines({ lines = [], className = "", lineClassName = "", start = 0.15, stagger = 0.14, duration = 1.15 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask" style={{ paddingBottom: "0.06em" }}>
          <motion.span
            style={{ display: "block", paddingBottom: "0.14em", marginBottom: "-0.14em" }}
            className={lineClassName}
            initial={{ y: "118%" }}
            animate={{ y: "0%" }}
            transition={{ duration, ease: EASE, delay: start + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Simple fade-in with delay (on load).
export function FadeIn({ children, delay = 0, y = 14, className, duration = 1 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export { EASE };
